import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  Output,
  EventEmitter,
  Inject,
  LOCALE_ID,
  ChangeDetectionStrategy,
} from "@angular/core";

import { gantt } from "dhtmlx-gantt";
import { TaskService } from "../services/task.service";
import { LinkService } from "../services/link.service";
import { Task } from "../models/task";
import {
  MatMenuTrigger,
  MatMenu,
  MatMenuContent,
  MatMenuItem,
} from "@angular/material/menu";
import { MatDialog } from "@angular/material/dialog";
import { DetailsComposantsComponent } from "../details-composants/details-composants.component";
import { LightboxOfComponent } from "../lightboxes/lightbox-of/lightbox-of.component";
import { LightboxOpComponent } from "../lightboxes/lightbox-op/lightbox-op.component";
import {
  configColumns,
  configLayout,
  configLayoutWithRessources,
  configScales,
  scaleConfigs,
} from "../utils/gantt-config-layout";
import { zoomConfig } from "../utils/gantt-zoom";
import { ApiService } from "../services/api.service";
import { Observable, of, Subject, Subscription, throwError } from "rxjs";
import * as moment from "moment";
import { LoadingService } from "../services/loading.service";
import { ErrorDialogComponent } from "../error-dialog/error-dialog.component";
import { LoadingDialogComponent } from "../loading-dialog/loading-dialog.component";
import { LightboxPosteComponent } from "../lightboxes/lightbox-poste/lightbox-poste.component";
import { MatIcon } from "@angular/material/icon";
import { MatProgressBar } from "@angular/material/progress-bar";
import { AsyncPipe } from "@angular/common";
import "./api.js";
import { first } from "rxjs/operators";
export const getLocale = () => {
  const item = JSON.parse(localStorage.getItem("plancUser"));
  return item === null ? "" : item.locale;
};
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  selector: "app-agil-gantt",
  styleUrls: ["./agil-gantt.component.css"],
  providers: [
    TaskService,
    LinkService,
    {
      provide: LOCALE_ID,
      useFactory: getLocale,
    },
  ],
  templateUrl: "./agil-gantt.component.html",
  standalone: true,
  imports: [
    MatProgressBar,
    MatMenuTrigger,
    MatMenu,
    MatMenuContent,
    MatMenuItem,
    MatIcon,
    AsyncPipe,
  ],
})
export class AgilGanttComponent implements OnInit {
  @ViewChild("gantt_here", { static: true }) ganttContainer: ElementRef;
  @ViewChild(MatMenuTrigger, { static: true }) contextMenuTask: MatMenuTrigger;
  @Output() zoomToFitEvtEmitter: EventEmitter<any> = new EventEmitter();
  contextMenuPosition = { x: "0px", y: "0px" };
  currentTaskType!: number;
  cachedSettings: any = {};
  scaleConfigs: any;
  param!: any;
  param$: Observable<any> = this.apiService.generateHttpRequest(
    null,
    "CalcCharges",
    null,
    "GET",
    null,
  );
  paramnSubscription!: Subscription;
  /**tasks dans leur état d'"origine au chargement afin de pouvoir comparer si des choses ont étées modifiées. */
  tasksLoaded = new Array<any>();
  /**tasks mises à jour par l'utilisateur */
  tasksUpdated = new Array<Task>();
  @Output() change$ = new Subject();
  nbTasks!: number;
  nbOfs!: number;
  saveDatas!: {};
  saveLinks!: {};
  /**
   * '1' tout
   * '2' week
   */
  viewType!: "1" | "2";
  OrdresFabrication: Map<number, any> = new Map<number, any>();
  constructor(
    private taskService: TaskService,
    private dialogDetailComposants: MatDialog,
    private dialogOf: MatDialog,
    private dialogOp: MatDialog,
    private apiService: ApiService,
    private loadingService: LoadingService,
    public dialog: MatDialog,
    @Inject(LOCALE_ID) public locale: string,
  ) {}
  ngOnInit(): void {
    this.init();
  }
  init(params?): void {
    this.paramnSubscription = this.apiService
      .generateHttpRequest(null, "CalcCharges", null, "GET", null)
      .subscribe((result) => {
        this.param = result;
        gantt.plugins({
          marker: true,
        });
        gantt.plugins({
          tooltip: true,
        });
        const localeCode = this.locale.split("-", 1);
        gantt.i18n.setLocale(localeCode[0]);
        gantt.config.xml_date = "%d-%m-%Y %H:%i";
        gantt.config.date_grid = "%d-%m-%Y %H:%i";
        gantt.config.show_links = false;
        // gantt.config.drag_project = true;
        gantt.config.work_time = true;
        gantt.config.drag_resize = false;
        gantt.config.autoscroll = true;
        gantt.config.autoscroll_speed = 50;

        gantt.config.duration_unit = "minute";
        gantt.setWorkTime({ hours: ["0:00-23:59"] });
        /** automatically extend the time scale in order to fit all displayed tasks */
        gantt.config.fit_tasks = true;
        gantt.config.min_column_width = 80;
        gantt.ext.zoom.init(zoomConfig(gantt));
        /** Autorise le resize manuel des rows */
        gantt.config.resize_rows = true;
        /** UX: scale par défaut sur le jour courant lors du chargement */
        gantt.config.scales = configScales();
        gantt.config.columns = configColumns();

        gantt.config.autosize = "y";
        gantt.config.task_height = "auto";
        // if (this.param.RowHeight) {
        //   gantt.config.row_height = this.param.RowHeight;
        // }

        /** Ajout dyn des class css car la couleur est paramétrable par l'utilisateur */
        if (this.param.TodayMarkerColor) {
          document.body.appendChild(
            Object.assign(document.createElement("style"), {
              textContent: `.today { background: ${this.param.TodayMarkerColor} !important;}`,
            }),
          );
        }
        if (this.param.CurrentWeekColor) {
          document.body.appendChild(
            Object.assign(document.createElement("style"), {
              textContent: `.current-week { background:  ${this.param.CurrentWeekColor} !important;}`,
            }),
          );
        }
        const currentWeek = this.currentWeek();

        gantt.templates.timeline_cell_class = (task, date) => {
          if (!gantt.isWorkTime(date)) {
            return "jour-chome";
          } else if (this.param.CurrentWeekColor) {
            const dateTest = new Date(date);
            dateTest.setHours(0, 0, 0, 0);
            const dateISO = dateTest.toISOString();
            if (
              dateTest.getDay() !== 0 &&
              dateTest.getDay() !== 6 &&
              currentWeek.some((d) => d === dateISO)
            ) {
              return "current-week";
            }
          }
          return "";
        };
        gantt.templates.tooltip_text = (start, end, task) => {
          //console.log("tooltip_text", start, end, task);

          return this.loadtoolTip(start, end, task);
        };

        // const ofLeftsideText = "DescCourte";
        // const ofLeftsideText = "'Article: ' || DescCourte || DescLongue || 'lala' ";
        gantt.templates.leftside_text = (start, end, task) => {
          // Of
          if (task.Type === 3) {
            const leftsideText = this.param.OfLeftsideText
              ? this.cimEval(this.param.OfLeftsideText, task)
              : "<b>" + $localize`Item` + ": </b>" + task.Article;
            return leftsideText;
          }
          // Op
          if (task.Type === 4) {
            const leftsideText = this.param.OPLeftsideText
              ? this.cimEval(this.param.OPLeftsideText, task)
              : "";
            return leftsideText;
          }
        };
        gantt.templates.rightside_text = (start, end, task) => {
          // Op
          if (task.Type === 4) {
            const rightsideText = this.param.OpRightsideText
              ? this.cimEval(this.param.OpRightsideText, task)
              : "<b>" + (task.Description ? task.Description : "") + "</b>";
            return rightsideText;
          }
          // Of
          if (task.Type === 3) {
            const rightsideText = this.param.OfRightsideText
              ? this.cimEval(this.param.OfRightsideText, task)
              : "";
            return rightsideText;
          }
        };
        gantt.templates.grid_row_class = (start, end, task) => {
          const css = [];
          if (gantt.hasChild(task.id)) {
            css.push("folder_row");
          }

          if (task.$virtual) {
            css.push("group_row");
          }

          return css.join(" ");
        };

        gantt.templates.task_row_class = () => {
          return "";
        };
        gantt.templates.resource_cell_class = (
          start_date,
          end_date,
          resource,
          tasks,
        ) => {
          var css = [];
          css.push("resource_marker");
          if (tasks.length <= 1) {
            css.push("workday_ok");
          } else {
            css.push("workday_over");
          }
          return css.join(" ");
        };

        gantt.templates.resource_cell_value = (
          start_date,
          end_date,
          resource,
          tasks,
        ) => {
          var result = 0;
          tasks.forEach(() => {
            const assignments = gantt.getResourceAssignments(resource.id);
            assignments.forEach((assignment) => {
              const task = gantt.getTask(assignment.task_id);
              if (resource.type === "work") {
                result += assignment.value * 1;
              } else {
                result += assignment.value / (task.duration || 1);
              }
            });
          });

          if (result % 1) {
            result = Math.round(result * 10) / 10;
          }
          return "<div>" + result + "</div>";
        };
        // Pour le titre des task on enlève "of: " et les 0000
        gantt.templates.task_text = (start, end, task) => {
          if (task.Type === 3) {
            //const text = task.text.replace("of: ", "").replace(/^0+/, "");
            // api send "'OF: '|| Of || 'Désignation:  '|| DescLongue\n'Client ' || NumClient || ' Commande ' || NumeroCde "
            //console.log("TextOfFormula", this.param.TextOfFormula);

            const text = this.param.TextOfFormula
              ? this.cimEval(this.param.TextOfFormula, task)
              : task.text.replace("of: ", "").replace(/^0+/, "");
            // const text = `${task.text}
            //   ${task.DescLongue} Client: ${task.NumClient}
            //   ${task.NumeroCde}`;

            return text.replace(/\n/g, "<br>");
          }
          if (task.Type === 4) {
            //const text = task.text.replace("op: ", "");
            const text = this.param.TextOpFormula
              ? this.cimEval(this.param.TextOpFormula, task)
              : task.text.replace("op: ", "").replace(/^0+/, "");
            return text.replace(/\n/g, "<br>");
          } else return task.text;
        };

        gantt.config.resource_store = "resource";
        gantt.config.resource_property = "resources";
        gantt.config.order_branch = true;
        gantt.config.open_tree_initially = true;
        gantt.config.scale_height = 50;
        gantt.config.layout = this.param.ShowRessources
          ? configLayoutWithRessources(gantt)
          : configLayout(gantt);
        /** add vertical marker for today */
        var dateToStr = gantt.date.date_to_str(gantt.config.task_date);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        if (this.param.TodayMarkerColor) {
          gantt.addMarker({
            start_date: today,
            css: "today",
            text: "Aujourd'hui",
            title: dateToStr(today),
          });
        }

        gantt.init(this.ganttContainer.nativeElement);

        gantt.attachEvent(
          "onBeforeTaskDrag",
          (id, mode, e) => {
            const task: Task = gantt.getTask(id);
            if (task.Type === 3 || task.Type === 4) {
              if (
                task.StatutOf === "L" ||
                task.StatutOf === "E" ||
                task.NonJalonnable === true
              ) {
                return false;
              }
            } else {
              return false;
            }
            return true;
          },
          null,
        );
        // TODO: onAfterTaskUpdate est déclenché si on redimensionne manuellement un row. BUG ?
        /** onAfterTaskUpdate */
        gantt.attachEvent(
          "onAfterTaskUpdate",
          (id, item) => {
            //   console.log(
            //     "onAfterTaskUpdate",
            //     item.Type,
            //     item.NonJalonnable,
            //     item.start_date,
            //   );
            const task: Task = {
              SeqOf: item.SeqOf,
              SeqOp: item.SeqOp,
              start_date: item.start_date,
              end_date: item.end_date,
              parent: item.parent,
              Type: item.Type,
              CapacitePoste: item.CapacitePoste,
              NonJalonnable: item.NonJalonnable,
              Poste: item.Poste,
              Interrompu: item.Interrompu,
              Priorite: item.Priorite,
            };

            const seq =
              task.Type === 3
                ? task.SeqOf
                : task.Type === 4
                  ? task.SeqOp
                  : null;
            if (seq) {
              const exist = this.tasksUpdated.some(
                (t) =>
                  (task.Type === 3 ? t.SeqOf === seq : t.SeqOp === seq) &&
                  t.Type === task.Type,
              );
              if (exist) {
                const i = this.tasksUpdated.findIndex(
                  (t) =>
                    (task.Type === 3 ? t.SeqOf === seq : t.SeqOp === seq) &&
                    t.Type === task.Type,
                );
                /** la task n'a pas encore été touchée,on la met à jour */
                this.tasksUpdated[i] = task;
              } else {
                /** sinon on l'ajoute' */
                this.tasksUpdated.push(task);
              }
            }
          },
          null,
        );
        /* Fired after onAfterTaskUpdate */
        gantt.attachEvent(
          "onAfterTaskDrag",
          (id, mode, e) => {
            const task: Task = gantt.getTask(id);
            const dialogRef = this.dialog.open(LoadingDialogComponent, {
              data: { title: "Mise à jour" },
            });
            dialogRef.afterOpened().subscribe(
              () => {
                if (task.Type === 3) {
                  this.updateTasksWhenOfIsUpdated(task);
                } else if (task.Type === 4) {
                  this.updateTasksWhenOpIsUpdated(task);
                }
              },
              () => {},
              /**  complete */
              () => {
                dialogRef.close();
              },
            );
          },
          null,
        );
        /** "onContextMenu" listener */
        gantt.attachEvent(
          "onContextMenu",
          (taskId, linkId, event) => {
            const taskTypeArray = [2, 3, 4];
            this.contextMenuPosition.x = event.clientX + "px";
            this.contextMenuPosition.y = event.clientY + "px";
            this.contextMenuTask.menu.focusFirstItem("mouse");
            if (taskId) {
              this.contextMenuTask.menuData = { task: gantt.getTask(taskId) };
              this.currentTaskType = gantt.getTask(taskId).Type;
              if (
                taskTypeArray.some(
                  (taskType) => taskType === gantt.getTask(taskId).Type,
                )
              ) {
                this.contextMenuTask.openMenu();
                return false;
              }
            }

            return true;
          },
          null,
        );
        /*
        Les tooltips sont tous chargés d’un coup par la librairie. Donc si on a 1000 ofs on va faire 1000 requêtes. Donc ici l'astuce c'est de ne charger qu'une seule fois l'oF quand la souris passe dessus, Avant le chargement du tooltip.
        Sachant que de toute façon le tooltip est redéclenché à chaque fois que la souris bouge sur la tâche
        **/
        gantt.attachEvent(
          "onMouseMove",
          (id, e: any) => {
            if (id !== null) {
              const task = gantt.getTask(id);

              // console.log("mousemove e", e);
              // const target = gantt.locate(e);
              // console.log("mousemove target", target);

              if (task) {
                //const task = gantt.getTask(target.task);
                //console.log("mousemouve task", task);
                if (
                  task.Type === 3 &&
                  this.param.TooltipOf &&
                  this.param.TooltipContentOf
                ) {
                  if (task.tooltipLoading) return;
                  if (this.OrdresFabrication.get(task.SeqOf)) return;
                  task.tooltipLoading = true;
                  const subof = this.apiService
                    .generateHttpRequest(
                      null,
                      "OrdreFabrication/GetEntete/" + task.SeqOf,
                      null,
                      "GET",
                      null,
                    )
                    .pipe(first());

                  subof.subscribe((of) => {
                    this.OrdresFabrication.set(task.SeqOf, of);
                  });
                }
              }
            }
          },
          null,
        );
        /** Show light boxes */
        gantt.showLightbox = (id) => {
          const task = gantt.getTask(id);
          /** Task Of */
          if (task.Type === 3) {
            this.showOfProperties(task);
            /** Task Op */
          } else if (task.Type === 4) {
            this.showOpProperties(task);
          } else if (task.Type === 2) {
            this.showPosteProperties(task);
          }
        };
        /** ressoures store */
        (gantt as any).$resourcesStore = gantt.createDatastore({
          name: gantt.config.resource_store,
          type: "treeDatastore",
          initItem: (item) => {
            item.parent = item.parent || gantt.config.root_id;
            item[gantt.config.resource_property] = item.parent;
            item.open = true;
            return item;
          },
        });
        /** Chargement via http du model pour le le Gantt*/
        this.loadDatas(params);
      });
  }
  /**
   * Retourne Liste des jours de la semaine courante au format ISO string
   * @returns Liste des jours de la semaine courante au format ISO string
   */
  currentWeek(): string[] {
    const currentDay = new Date();
    const currentWeek = [];

    for (let i = 1; i <= 7; i++) {
      const first = currentDay.getDate() - currentDay.getDay() + i;
      currentDay.setDate(first);
      currentDay.setHours(0, 0, 0, 0);
      const day = new Date(currentDay).toISOString();
      currentWeek.push(day);
    }
    return currentWeek;
  }
  /**
   * Retourne Liste des jours de la semaine courante
   * @returns Liste des jours de la semaine courante
   */
  daysOfcurrentWeek(): Date[] {
    const currentDay = new Date();
    const currentWeek = [];

    for (let i = 1; i <= 7; i++) {
      const first = currentDay.getDate() - currentDay.getDay() + i;
      currentDay.setDate(first);
      currentDay.setHours(0, 0, 0, 0);
      const day = new Date(currentDay);
      currentWeek.push(day);
    }
    return currentWeek;
  }
  /** https://docs.dhtmlx.com/gantt/desktop__filtering.html */
  filterDatas(ok = true) {
    // if (ok) {
    //   this.saveDatas = gantt.gettask
    //   gantt.parse({ data, links });
    // }
  }
  loadGantt(params?) {
    gantt.resetLayout();
    gantt.clearAll();
    gantt.detachAllEvents();
    this.init(params);

    // this.restoreConfig();
  }
  /**
   * Chargement via http du model pour le Gantt
   */
  loadDatas(params?) {
    this.loadingService.load(true);
    this.change$.next(true);
    this.taskService.getWithExtraParams(params).then((result) => {
      this.nbTasks = result.NbTask;
      this.nbOfs = [
        ...new Set(
          result.ganttModel.Tasks.filter((task: Task) => task.Type === 3).map(
            (task) => task.SeqOf,
          ),
        ),
      ].length;
      const data = result.ganttModel.Tasks.map((task: Task) => {
        task.readonly = task.Readonly;
        task.task_text = "test";
        /** si on cache les tasks Of */
        if (task.Type === 3 && this.param.HideOfTask) {
          //task.bar_height = 1;
          task.row_height = 1;
        }
        /** si on cache les tasks Op */
        if (task.Type === 4 && this.param.NonVisuop) {
          task.row_height = 1;
        }
        if (task.Type === 0) {
          task.color = this.param.EntBackground;
          task.textColor = this.param.EntTextcolor;
          if (this.param.RowHeightEnt) {
            task.row_height = this.param.RowHeightEnt;
          }
        } else if (task.Type === 1) {
          task.color = this.param.CentreBackground;
          task.textColor = this.param.CentreTextcolor;
          if (this.param.RowHeightCent) {
            task.row_height = this.param.RowHeightCent;
          }
        } else if (task.Type === 2) {
          task.color = this.param.PosteBackground;
          task.textColor = this.param.PosteTextcolor;
          if (this.param.RowHeightPoste) {
            task.row_height = this.param.RowHeightPoste;
          }
        } else if (task.Type === 3) {
         if (this.param.RowHeight) {
            task.row_height = this.param.RowHeight;
          }
          switch (task.StatutOf) {
            case "E":
              task.color = this.param.OfEBackground;
              task.textColor = this.param.OfETextcolor;
              break;
            case "L":
              task.color = this.param.OfLBackground;
              task.textColor = this.param.OfLTextcolor;
              break;
            case "P":
              task.color = this.param.OfPBackground;
              task.textColor = this.param.OfPTextcolor;
              break;
            case "F":
              task.color = this.param.OfLBackground;
              task.textColor = this.param.OfLTextcolor;
              break;
            default:
          }
        } else if (task.Type === 4) {
          task.color = this.param.OPBackground;
          task.textColor = this.param.OPTextcolor;
          if (this.param.RowHeightOp) {
            task.row_height = this.param.RowHeightOp;
          }
        }
        return task;
      });
      // this.tasksLoaded = JSON.parse(JSON.stringify(data));
      const links = [];
      if (result.ganttModel.joursChomesModel?.SamediChome === "1") {
        gantt.setWorkTime({ day: 6, hours: false });
      }
      if (result.ganttModel.joursChomesModel?.DimancheChome === "1") {
        gantt.setWorkTime({ day: 7, hours: false });
      }
      result.ganttModel.joursChomesModel?.JoursChomes?.forEach((jourChome) => {
        gantt.setWorkTime({ date: new Date(jourChome), hours: false });
      });
      (gantt as any).$resourcesStore.parse(result.ganttModel.ResourcesStore);
      /** loads data from 'data' */
      gantt.parse({ data, links });
      /** Inittialisation des last_xxx_date. Il faut le faire ici après le parse pour qu'elles soient parsées au bon format */
      gantt.eachTask((task: Task) => {
        task.last_start_date = new Date(task.start_date.getTime());
        task.last_end_date = new Date(task.end_date.getTime());
      });

      // nécéssaire pour que le zoom auto fit
      // TODO DEFINIR LA VALEUR EN FONCTION DE L'ECART ENTRE START ET END DATE
      gantt.ext.zoom.setLevel("month");
      if (this.viewType === "2") {
        this.zoomToWeek();
      }
      this.change$.next(false);
      this.loadingService.load(false);
    });
  }
  loadtoolTip(start: Date, end: Date, task: any) {
    if (
      task.Type === 3 &&
      this.param.TooltipOf &&
      this.param.TooltipContentOf
    ) {
      const ordreFab = this.OrdresFabrication.get(task.SeqOf);
      if (!ordreFab) return;
      const jsonContent = JSON.parse(this.param.TooltipContentOf);
      let tooltip = ` <div class="gantt-tooltip-card">
            <div class="gantt-tooltip-title">
                 ${task.text}
             </div>
             
             <div class="gantt-tooltip-section">
             `;
      jsonContent.content.forEach(
        (content: { label: string; value: string }) => {
          if (!content.label && content.value === "divider") {
            tooltip += ` </div>
                  <div class="gantt-tooltip-separator"></div>
                    <div class="gantt-tooltip-section">`;
          } else {
            tooltip += `<div><span>${content.label}</span> ${this.cimEval(content.value, ordreFab)}</div>`;
          }
        },
      );
      tooltip += `</div>
              </div>`;
      return tooltip;
    } else return null;
  }
  loadtoolTipWithApi(start: Date, end: Date, task: any) {
    if (
      task.Type === 3 &&
      this.param.TooltipOf &&
      this.param.TooltipContentOf
    ) {
      const ordreFab = this.OrdresFabrication.get(task.SeqOf)
        ? of(this.OrdresFabrication.get(task.SeqOf))
        : this.apiService
            .generateHttpRequest(
              null,
              "OrdreFabrication/GetEntete/" + task.SeqOf,
              null,
              "GET",
              null,
            )
            .pipe(first());

      ordreFab.subscribe((of) => {
        // this.OrdresFabrication.set(task.SeqOf, of);
        const jsonContent = JSON.parse(this.param.TooltipContentOf);
        let tooltip = ` <div class="gantt-tooltip-card">
            <div class="gantt-tooltip-title">
                 ${task.text}
             </div>
             
             <div class="gantt-tooltip-section">
             `;
        jsonContent.content.forEach(
          (content: { label: string; value: string }) => {
            if (!content.label && content.value === "divider") {
              tooltip += ` </div>
                  <div class="gantt-tooltip-separator"></div>
                    <div class="gantt-tooltip-section">`;
            } else {
              tooltip += `<div><span>${content.label}</span> ${this.cimEval(content.value, of)}</div>`;
            }
          },
        );
        tooltip += `</div>
              </div>`;
        return tooltip;
      });
    } else return null;
  }
  loadtoolTipFake(start: Date, end: Date, task: any) {
    console.log("loadtoolTipFake, tache Type: ", task.Type);
    if (
      task.Type === 3 &&
      this.param.TooltipOf &&
      this.param.TooltipContentOf
    ) {
      return `
              <div class="gantt-tooltip-card">
                  <div class="gantt-tooltip-title">
                      ${task.text}
                  </div>

                  <div class="gantt-tooltip-section">
                      <div><span>📅 Début</span> ${gantt.templates.tooltip_date_format(start)}</div>
                      <div><span>📅 Fin</span> ${gantt.templates.tooltip_date_format(end)}</div>
                      <div><span>⏱ Durée</span> ${task.duration} jours</div>
                  </div>

                  <div class="gantt-tooltip-separator"></div>

                  <div class="gantt-tooltip-section">
                      <div><span>🧾 Article</span> ${task.Article || "-"}</div>
                      <div><span>📦 Désignation</span> ${task.DescLongue || "-"}</div>
                      <div><span>👤 Client</span> ${task.NumClient || "-"}</div>
                      <div><span>📄 Commande</span> ${task.NumeroCde || "-"}</div>
                  </div>
              </div>
          `;
    } else return null;
  }
  ngOnDestroy(): void {
    this.paramnSubscription?.unsubscribe();
  }
  /**
   * Ouvre la dialog Composants
   * @param item
   */
  detailsComposants(item) {
    const dialogRef = this.dialogDetailComposants.open(
      DetailsComposantsComponent,
      {
        width: "900px",
        data: { task: item },
      },
    );

    dialogRef.afterClosed().subscribe(() => {});
  }
  /**
   * met à jour les tasks si un of a été modifié manuellement
   * @param task task responsable
   * @param start_date_orig
   * @param end_date_orig
   */
  updateTasksWhenOfIsUpdated(task: Task) {
    const startDifference =
      task.start_date.valueOf() - task.last_start_date.valueOf();

    // iterates over all child tasks of a specific task or the of whole Gantt chart
    gantt.eachTask((oneTask: Task) => {
      // mise àjour des autres task of du même of (si celui ci est dispatché sur différent Centres et/ou Postes)
      if (oneTask.Type === 3 && oneTask.SeqOf === task.SeqOf) {
        oneTask.start_date = task.start_date;
        oneTask.end_date = task.end_date;
        // /** Mise à jour de NonJalonnable */
        oneTask.NonJalonnable = task.NonJalonnable;
        oneTask.Priorite = task.Priorite;
        oneTask.Interrompu = task.Interrompu;
        this.updateTask(oneTask.id);
      } else if (oneTask.Type === 4 && oneTask.SeqOf === task.SeqOf) {
        let mustBeUpdated = false;
        /** On applique la différence sur les dates */
        if (startDifference) {
          const momentSart = moment(oneTask.start_date);
          momentSart.add(startDifference, "ms");
          oneTask.start_date = momentSart.toDate();

          /** On utilise calculateEndDate afin de recalculer la date de fin en tenant compte des jours chomés */
          /** Pour l'instant on ne bouge que la date de début. En effet il faut ce que l'on fait si l'of change de LONGUEUR (redimensionnement des ops au prorata ?)*/
          oneTask.end_date = gantt.calculateEndDate(oneTask);

          /** Mise à jour de NonJalonnable */
          oneTask.NonJalonnable = task.NonJalonnable;
          //oneTask.Interrompu = task.Interrompu;
          //oneTask.Priorite = task.Priorite;
          oneTask.last_start_date = oneTask.start_date;
          oneTask.last_end_date = oneTask.end_date;
          mustBeUpdated = true;
          // this.updateTask(oneTask.id);
        }
        if (oneTask.NonJalonnable !== task.NonJalonnable) {
          /** Mise à jour de NonJalonnable */
          oneTask.NonJalonnable = task.NonJalonnable;
          mustBeUpdated = true;
        }
        /*
        if (oneTask.Priorite !== task.Priorite) {          
          oneTask.Priorite = task.Priorite;
          mustBeUpdated = true;
        }
        
        if (oneTask.Interrompu !== task.Interrompu) {
                    oneTask.Interrompu = task.Interrompu;
          mustBeUpdated = true;
        }
        */
        if (mustBeUpdated) {
          this.updateTask(oneTask.id);
        }
      }
      oneTask.last_start_date = oneTask.start_date;
      oneTask.last_end_date = oneTask.end_date;
    });
    task.last_start_date = task.start_date;
    task.last_end_date = task.end_date;
    /** Update la task Of, nécéssaire pour la date de fin */
    this.updateTask(task.id);
    gantt.render();
  }
  /**
   * met à jour les tasks si une op a été modifiée manuellement
   * @param task task responsable
   */
  updateTasksWhenOpIsUpdated(task: Task) {
    /** On utilise calculateEndDate afin de recalculer la date de fin en tenant compte des jours chomés */
    task.end_date = gantt.calculateEndDate(task);
    const startDifference =
      task.start_date.valueOf() - task.last_start_date.valueOf();
    // iterates over all child tasks of the of whole Gantt chart
    gantt.eachTask((oneTask: Task) => {
      /**mise àjour des autres task of du même of*/
      if (
        oneTask.id !== task.id &&
        (oneTask.Type === 3 || oneTask.Type === 4) &&
        oneTask.SeqOf === task.SeqOf
      ) {
        /** Mise à jour de NonJalonnable */
        oneTask.NonJalonnable = task.NonJalonnable;
        /** On applique la différence sur les dates */
        if (startDifference) {
          const momentSart = moment(oneTask.start_date);
          momentSart.add(startDifference, "ms");
          oneTask.start_date = momentSart.toDate();
          /** On utilise calculateEndDate afin de recalculer la date de fin en tenant compte des jours chomés */
          oneTask.end_date = gantt.calculateEndDate(oneTask);
          /** Mise à jour de NonJalonnable */
          oneTask.NonJalonnable = task.NonJalonnable;
          oneTask.last_start_date = oneTask.start_date;
          oneTask.last_end_date = oneTask.end_date;
          this.updateTask(oneTask.id);
        }
      }
    });
    task.last_start_date = new Date(task.start_date.getTime());
    task.last_end_date = new Date(task.end_date.getTime());
    /** Update la task Op */
    this.updateTask(task.id);
    gantt.render();
  }
  /**
   * Ouvre la dialog Of
   * @param task Of
   */
  showOfProperties(task: Task) {
    const dialogRef = this.dialogOf.open(LightboxOfComponent, {
      width: "900px",
      data: { task: { ...task }, gantt: gantt },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        task.start_date = result.start_date;
        task.end_date = result.end_date;
        task.NonJalonnable = result.NonJalonnable;
        task.Priorite = result.Priorite;
        task.Interrompu = result.Interrompu;
        const dialogRef = this.dialog.open(LoadingDialogComponent, {
          data: { title: "Mise à jour" },
        });
        dialogRef.afterOpened().subscribe(
          () => {
            this.updateTasksWhenOfIsUpdated(task);
          },
          () => {},
          /**  complete */
          () => {
            dialogRef.close();
          },
        );
      }
    });
  }
  /**
   * Ouvre la dialog Op
   * @param task Op
   */
  showOpProperties(task: Task) {
    const dialogRef = this.dialogOp.open(LightboxOpComponent, {
      height: "99%",
      data: { task: { ...task }, param: this.param, gantt: gantt },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        task.start_date = result.start_date;
        task.end_date = result.end_date;
        task.CapacitePoste = result.CapacitePoste;
        task.Poste = result.Poste;
        const dialogRef = this.dialog.open(LoadingDialogComponent, {
          data: { title: "Mise à jour" },
        });
        dialogRef.afterOpened().subscribe(
          () => {
            this.updateTasksWhenOpIsUpdated(task);
          },
          () => {},
          /**  complete */
          () => {
            dialogRef.close();
          },
        );
      }
    });
  }
  /**
   * Ouvre la dialog Poste
   * @param task Poste
   */
  showPosteProperties(task: Task) {
    const dialogRef = this.dialogOp.open(LightboxPosteComponent, {
      width: "900px",
      data: { task: { ...task } },
    });
    dialogRef.afterClosed().subscribe();
  }
  updateTask(taskId) {
    const task = gantt.getTask(taskId);
    gantt.updateTask(task.id);
  }
  restoreConfig() {
    this.applyConfig(this.cachedSettings, null);
  }
  saveConfig() {
    const config = gantt.config;
    this.cachedSettings = {};
    this.cachedSettings.scales = config.scales;
    this.cachedSettings.start_date = config.start_date;
    this.cachedSettings.end_date = config.end_date;
    this.cachedSettings.scroll_position = gantt.getScrollState();
  }
  applyConfig(config, dates) {
    gantt.config.scales = config.scales;

    // restore the previous scroll position
    if (config.scroll_position) {
      setTimeout(function () {
        gantt.scrollTo(config.scroll_position.x, config.scroll_position.y);
      }, 4);
    }
  }

  zoomToFit() {
    this.viewType = "1";
    var project = gantt.getSubtaskDates(),
      areaWidth = (gantt as any).$task.offsetWidth,
      scaleConfigs = zoomConfig(gantt).levels;

    for (var i = 0; i < scaleConfigs.length; i++) {
      var columnCount = this.getUnitsBetween(
        project.start_date,
        project.end_date,
        scaleConfigs[i].scales[scaleConfigs[i].scales.length - 1].unit,
        scaleConfigs[i].scales[0].step,
      );
      if ((columnCount + 2) * gantt.config.min_column_width <= areaWidth) {
        break;
      }
    }

    if (i == scaleConfigs.length) {
      i--;
    }

    gantt.ext.zoom.setLevel(scaleConfigs[i].name);
    this.applyConfig(scaleConfigs[i], project);
  }
  zoomToWeek() {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    today.setDate(today.getDate() - 2);
    gantt.ext.zoom.setLevel("half_day");
    gantt.scrollTo(gantt.posFromDate(today), null);
    this.viewType = "2";
    this.saveConfig();
  }
  // get number of columns in timeline
  getUnitsBetween(from, to, unit, step) {
    var start = new Date(from),
      end = new Date(to);
    var units = 0;
    while (start.valueOf() < end.valueOf()) {
      units++;
      start = gantt.date.add(start, step, unit);
    }
    return units;
  }
  zoom_in() {
    gantt.ext.zoom.zoomIn();
    this.viewType = null;
    this.saveConfig();
  }
  zoom_out() {
    gantt.ext.zoom.zoomOut();
    this.viewType = null;
    this.saveConfig();
  }
  getUnitsBetweenOld(from, to, unit, step) {
    let start = new Date(from);
    const end = new Date(to);
    let units = 0;
    while (start.valueOf() < end.valueOf()) {
      units++;
      start = gantt.date.add(start, step, unit);
    }
    return units;
  }
  refresh() {
    window.location.reload();
  }
  /**
   * Jalonnement
   */
  jalon() {
    const dialogRef = this.dialog.open(LoadingDialogComponent, {
      disableClose: true,
      data: { title: "Jalonnement global" },
    });
    dialogRef.afterOpened().subscribe(() => {
      this.apiService
        .generateHttpRequest(null, "gantt/jalon", null, "GET", null)
        .subscribe(
          (result) => {
            dialogRef.close();
            /** Note j'utilise ErrorDialogComponent comme boite de notif */
            const dialogInfo = this.dialog.open(ErrorDialogComponent, {
              data: {
                origin: "jalon",
                NoLanctBatch: result,
                title: "Jalonnement terminé",
              },
            });
            dialogInfo.afterClosed().subscribe(() => {
              window.location.reload();
            });
          },
          (err) => {
            dialogRef.close();
          },
        );
    });
  }
  /**
   * Sauvegarde
   */
  save() {
    this.apiService
      .generateHttpRequest(null, "gantt", this.tasksUpdated, "PUT", null)
      .subscribe(
        (result) => {
          // console.log("saved ! " + result);
          window.location.reload();
        },
        /** error */
        () => {},
        /**  complete */
        () => {
          this.tasksUpdated = [];
          // console.log("save complete");
        },
      );
  }
  /**
   * Ferme/Ouvre les taches d'un type (utilisé par ex pour fermer tous les centres ou tous les postes)
   * @param taskType
   * @param open
   */
  closeOpenAll(taskType, open) {
    gantt.eachTask(function (task) {
      if (task.Type === taskType) {
        task.$open = open;
      }
    });
    gantt.render();
  }
  export(type: "PDF" | "EXCEL" | "PNG") {
    switch (type) {
      case "PDF":
        gantt.exportToPDF({
          name: "mygantt.pdf",
        });
        break;
      case "EXCEL":
        gantt.exportToExcel({
          name: "mygantt.xlsx",
        });
        break;
      case "PNG":
        gantt.exportToPNG({
          name: "mygantt.png",
        });
        break;
    }
  }
  cimEval(expression: string, task: any): string {
    /**  Ex reçu de l'api: "'OF: '|| Of || 'Désignation:  '|| DescLongue
   'Client ' || NumClient || ' Commande ' || NumeroCde "*/
    //console.log("expression", expression);
    let result = "";
    const lines = expression.split("\n");
    lines.forEach((line, index) => {
      const values = line.trim().split("||");

      values.forEach((value) => {
        value = value.trim();

        /** Si la valeur est entourée de simples ou doubles cotes c'est à prendre en l'état */
        if (
          (value.substring(0, 1) === "'" || value.substring(0, 1) === '"') &&
          (value.slice(-1) === "'" || value.slice(-1) === '"')
        ) {
          result += value.substring(1, value.length - 1);
        } /** Sinon on prend la valeur dans la tâche */ else {
          if (task.hasOwnProperty(value)) {
            result += task[value];
          }
        }
      });
      const hasReturn = index !== lines.length - 1;
      if (hasReturn) {
        result += "\n";
      }
      // result: OF: 0000000072Désignation:  CARREFOUR Commande 0000000012
      // le retour à la ligne a disparu !
      //console.log("result", result);
    });
    return result;
  }
  cimEvalTableau(expression: string, task: any): string {
    return "";
  }
}
